export default __webpack_public_path__ + "static/media/panelData3.1c6c9c6f.png";